const routes = [
    {
        name: 'listarLojasEmissor',
        path: '/emissor/lojas',
        alias: '/emissor/lojas/index',
        component: () => import('@/domains/shared/configuracoes/lojas/views/Listar')
    },
    {
        name: 'adicionarLojaEmissor',
        path: '/emissor/lojas/adicionar',
        component: () => import('@/domains/shared/configuracoes/lojas/views/Adicionar'),
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'editarLojaEmissor',
        path: '/emissor/lojas/editar/:id',
        component: () => import('@/domains/shared/configuracoes/lojas/views/Editar'),
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'visualizarLojaEmissor',
        path: '/emissor/lojas/visualizar/:id',
        component: () => import('@/domains/shared/configuracoes/lojas/views/Visualizar'),
    }
]

export default routes